import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import router from '@/../src/router/index'
import axios from 'axios'

let state = {
  Forseti_Catalogos_001TiposEstatusDeAudiencia: [],
  Forseti_Catalogos_005TiposMarcador: [],
  Forseti_Catalogos_015TiposDistorsionesDeAudio: [],
  Forseti_Sistema_TiempoActualVideo: []
}

let mutations = {
  M_Forseti_Catalogos_001TipoEstatusDeAudiencia(state, data) {
    state.Forseti_Catalogos_001TiposEstatusDeAudiencia[data.llave] = data.valor;
  },
  M_Forseti_Catalogos_005TipoMarcador(state, data) {
    state.Forseti_Catalogos_005TiposMarcador[data.llave] = data.valor;
  },
  M_Forseti_Catalogos_015TipoDistorsionDeAudio(state, data) {
    state.Forseti_Catalogos_015TiposDistorsionesDeAudio[data.llave] = data.valor;
  },
  M_Forseti_Sistema_TiempoActualVideo(state, data) {    
    state.Forseti_Sistema_TiempoActualVideo[data.llave] = data.valor;
  }
}

let actions = {
  A_Forseti_Catalogo_Establecer001TipoEstatusDeAudiencia: ({ commit }, data) => {
    commit('M_Forseti_Catalogos_001TipoEstatusDeAudiencia', data);
  },
  A_Forseti_Catalogo_Establecer005TipoMarcador: ({ commit }, data) => {
    commit('M_Forseti_Catalogos_005TipoMarcador', data);
  },
  A_Forseti_Catalogo_Establecer015TipoDistorsionDeAudio: ({ commit }, data) => {
    commit('M_Forseti_Catalogos_015TipoDistorsionDeAudio', data);
  },
  A_Forseti_Catalogo_EstablecerTiempoActualVideo: ({ commit }, data) => {
    commit('M_Forseti_Sistema_TiempoActualVideo', data);
  }
}

const Forseti = {
  State: state,
  Mutations: mutations,
  Actions: actions
}
export default Forseti;



// WEBPACK FOOTER //
// ./src/store/Forseti.js